module.exports = __webpack_public_path__ + "img/Z85-X18-中_01.aca66f30.jpg";